
// Note:  while this is a trivially simple view model class, trying to merely post a string
//        as a view model did not work.Hence the creation of this simple class.
export class FormsGridRowOrderData {
    public constructor(public mapOfFormsGridOrdersJson: string) { }
}
